import Api from '../constants/Api';
import axiosInstance from '../services/AxiosInstance';
import { SearchOperation } from './ApiUtils';

/**
 * Situação do saldo de um produto numa filial.
 *
 * UNTRACKED  - produto sem controle de estoque; a venda nunca é barrada.
 * BRANCH     - filial ainda não escolhida, então não há saldo para consultar.
 * UNAVAILABLE- não foi possível consultar (erro ou produto sem registro de estoque).
 *              Ausência de cadastro não é confirmação de saldo zero, então não barra.
 * EMPTY      - saldo zerado ou negativo.
 * AVAILABLE  - há saldo; `qty` traz quanto.
 */
export const ProductStockStatus = {
    UNTRACKED: 'untracked',
    BRANCH: 'branch',
    UNAVAILABLE: 'unavailable',
    EMPTY: 'empty',
    AVAILABLE: 'available'
};

/**
 * Consulta o saldo do produto na filial.
 *
 * Fonte única do frontend para o estoque de um item da venda: o aviso exibido
 * abaixo do item e o bloqueio no "Adicionar item" leem o mesmo resultado, para
 * não divergirem entre si.
 */
export async function fetchProductStock(productId, branchId) {
    if (!productId) {
        return { status: ProductStockStatus.UNTRACKED, qty: null };
    }

    try {
        const { data: details } = await axiosInstance.get(`${Api.main.product}/${productId}`);

        // Serviço e produto sem controle de estoque não têm saldo a respeitar.
        if (details.trackStock !== true) {
            return { status: ProductStockStatus.UNTRACKED, qty: null };
        }

        if (!branchId) {
            return { status: ProductStockStatus.BRANCH, qty: null };
        }

        const { data } = await axiosInstance.post(`${Api.stock_control.stock}/pageable`, {
            filters: [
                { field: 'product.id', operation: SearchOperation.EQUAL, value: productId },
                { field: 'branch.id', operation: SearchOperation.EQUAL, value: branchId }
            ],
            page: 0,
            size: 1
        });

        const qty = data.content?.[0]?.qty;
        if (qty == null) {
            return { status: ProductStockStatus.UNAVAILABLE, qty: null };
        }

        return {
            status: qty <= 0 ? ProductStockStatus.EMPTY : ProductStockStatus.AVAILABLE,
            qty
        };
    } catch {
        return { status: ProductStockStatus.UNAVAILABLE, qty: null };
    }
}
